export default __webpack_public_path__ + "locales/ru/RoomLogoCover.json?hash=ab67d5150e46b9124ab17fa6835ff7f0";